import Splide from '@splidejs/splide';

export function sliderSmartControlInit() {
  const bgSliderEl = document.querySelector('[data-slider-control-bg]');
  const bgSlider = new Splide(bgSliderEl, {
    type: 'loop',
    focus: 'center',
    autoWidth: true,
    gap: 10,
    perMove: 1,
    speed: 300,
    rewind: true,
    arrows: true,
    pagination: false,
    cssEase: 'linear',
  });

  const deviceSlides = document.querySelectorAll(
    '[data-slider-smart-control-device-slide]'
  );
  const contentSlides = document.querySelectorAll(
    '[data-slider-smart-control-content-slide]'
  );

  bgSlider.on('mounted', () => {
    const activeSlideIndex = bgSlider.index;

    deviceSlides[activeSlideIndex].setAttribute('data-active', 'true');
    contentSlides[activeSlideIndex].setAttribute('data-active', 'true');
  });

  bgSlider.on('move', (dest) => {
    deviceSlides.forEach((deviceSlide) => {
      deviceSlide.removeAttribute('data-active');
    });

    contentSlides.forEach((contentSlide) => {
      contentSlide.removeAttribute('data-active');
    });

    deviceSlides[dest].setAttribute('data-active', 'true');
    contentSlides[dest].setAttribute('data-active', 'true');
  });

  bgSlider.mount();
}
